export function consumeOneTimeNotification(source, key, present) {
    if (!source || typeof present !== 'function') {
        return false;
    }

    const message = source[key];

    if (typeof message !== 'string' || message.trim() === '') {
        return false;
    }

    delete source[key];
    present(message);

    return true;
}
